import { render, staticRenderFns } from "./AppCredentials.vue?vue&type=template&id=f52a5288"
import script from "./AppCredentials.vue?vue&type=script&lang=ts"
export * from "./AppCredentials.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports